module.exports = __webpack_public_path__ + "static/media/2loop2.c18eea93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/2loop2.jpg
// module id = 287
// module chunks = 0